export default __webpack_public_path__ + "static/media/mood-tracker.8c5a4f08.svg";